import styled, { css } from 'styled-components';
import { AlignCenter, ShowVerticalScrollbar } from '../../../global/commonStyle';

const CommentInputSection = styled.div<{ isApplyManualHeight?: boolean }>`
  background-color: var(--background-primary);
  box-shadow: var(--shadow-card);
  padding: var(--space-12);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  position: relative;
  margin-bottom: var(--space-12);
  .tiptap {
    min-height: 40px;
    max-height: 240px;
    ${ShowVerticalScrollbar}
    ${({ isApplyManualHeight }) =>
      isApplyManualHeight &&
      css`
        min-height: 100px;
      `}
  }
  .icon {
    width: 18px;
    height: 18px;
    stroke: var(--text-secondary);
  }
  .text {
    p + img {
      margin: var(--space-10) var(--space-0) var(--space-0);
    }
  }
`;

const IconSection = styled.div`
  ${AlignCenter}
  justify-content: end;
  gap: var(--space-7);
  margin-top: var(--space-6);
  .active {
    svg {
      fill: var(--text-primary);
    }
  }
`;
const Icon = styled.div`
  position: relative;
  cursor: pointer;
`;
const UploadDiv = styled.div`
  color: var(--text-primary);
`;

const FileBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-10);
  margin-block: var(--space-12) var(--space-0);
  padding: var(--space-0);
`;

export { CommentInputSection, IconSection, Icon, UploadDiv, FileBox };
